import { render, staticRenderFns } from "./Edit-catalog.vue?vue&type=template&id=97d3cf46&scoped=true"
import script from "./Edit-catalog.vue?vue&type=script&lang=js"
export * from "./Edit-catalog.vue?vue&type=script&lang=js"
import style0 from "./Edit-catalog.vue?vue&type=style&index=0&id=97d3cf46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d3cf46",
  null
  
)

export default component.exports